import { apiFetch } from './client';
import type { Page } from './discover';

/**
 * Moderation (Phase 16).
 *
 * Every call here answers 403 to anybody without the moderator role, whatever
 * this file does. `role` on `/me` is how the app knows not to offer the screen;
 * it is never what decides.
 */

export interface QueueEntry {
  id: string;
  number: number;
  title: string;
  subtitle: string;
  submitted_at: string;
  post: { id: string; visibility: string };
  author: { handle: string; display_name: string };
  /** How many times this story has been decided about before. */
  history_count: number;
}

export interface Decided {
  id: string;
  number: number;
  status: string;
  post: { id: string; status: string };
}

function send<T>(path: string, method: string, body?: unknown): Promise<T> {
  return apiFetch<T>(path, {
    method,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body ?? {}),
  });
}

export const listQueue = (page = 1): Promise<Page<QueueEntry>> =>
  apiFetch<Page<QueueEntry>>(`/moderation/queue${page > 1 ? `?page=${page}` : ''}`);

export const approve = (versionId: string, reason = ''): Promise<Decided> =>
  send<Decided>(`/moderation/versions/${versionId}/approve`, 'PUT', { reason });

export const reject = (versionId: string, reason: string): Promise<Decided> =>
  send<Decided>(`/moderation/versions/${versionId}/reject`, 'PUT', { reason });

export const hideStory = (postId: string, reason: string) =>
  send<{ id: string; status: string }>(`/moderation/stories/${postId}/hidden`, 'PUT', { reason });

export const unhideStory = (postId: string) =>
  apiFetch<{ id: string; status: string }>(`/moderation/stories/${postId}/hidden`, {
    method: 'DELETE',
  });
